import LoginPage from '../containers/LoginPage';
import HomePage from '../containers/HomePage';
import TerminalsPage from '../containers/TerminalsPage';
import PartsPage from '../containers/PartsPage';
import CompaniesPage from '../containers/CompaniesPage';
import StepPage from '../containers/TerminalSwitchPage';
import UsersPage from '../containers/UsersPage';
import StationsPage from '../containers/StationsPage';

import HomeIcon from "@material-ui/icons/Home";
import DevicesIcon from "@material-ui/icons/Devices";
import BuildIcon from "@material-ui/icons/Build";
import BusinessIcon from "@material-ui/icons/Business";
import PeopleIcon from "@material-ui/icons/People";
import SwapCallsIcon from "@material-ui/icons/SwapCalls";
import EvStationIcon from "@material-ui/icons/EvStation";


/* 
This is the place where all the page routes and
those creations are made by spesific role.
This is, so there is one unified place to handle the 
user roles access and to show navigation according to those
role restrictions. 
*/ 


// This pageMap contains all the different pages for user, where user can navigate
// When adding a new page for app, list it here
const pageMap = new Map();
pageMap.set("LoginPage", {name: "Login", path: "/login", component: "LoginPage"});
pageMap.set("HomePage", {name: "Home", path: "/home", component: "HomePage"});
pageMap.set("StationsPage", {name: "Stations", path: "/stations", component: "StationsPage"});
pageMap.set("TerminalsPage", {name: "Terminals", path: "/terminals", component: "TerminalsPage"});
pageMap.set("CompaniesPage", {name: "Companies", path: "/companies", component: "CompaniesPage"});
pageMap.set("PartsPage", {name: "Parts", path: "/parts", component: "PartsPage"});
pageMap.set("TerminalSwitchPage", {name: "Switch", path: "/terminalswitch", component: "TerminalSwitchPage"});
pageMap.set("UsersPage", {name: "Users", path: "/users", component: "UsersPage"});

// Creates an array of routes for spesific user
// This contains normal routes and also subroutes
export const createAllowedRoutes = (role) => {
  let routeList;

  switch (role) {
    case "admin":
        routeList = createAdminRoleRoutes();
        break;
    case "user":
        routeList = createUserRoleRoutes();
        break;
    case "helpdesk":
      routeList = createHelpDeskRoleRoutes();
      break;
    case "viewer":
      routeList = createViewerRoleRoutes();
      break;
    case null:
        routeList = createNullRoleRoutes();
        break;
    default:
        routeList = createNullRoleRoutes();
        break;
  }
  return routeList;
}

/*
This implementation supports basic routes in array, but also
categorized routes, which are used for example in navigation menus
For example 
[
  {name: "HomePage"...}, 
  {name: "TerminalsPage"...}, 
  {title: Controls, [
    {name: "CompaniesPage"}
  ]}
]
*/
function createAdminRoleRoutes() {
  let pages;
  pages = getPages(["HomePage", "TerminalsPage", "PartsPage", "StationsPage", "TerminalSwitchPage", "CompaniesPage", "UsersPage"]);
  // Sub links are also possible like so:
  // pages.push({title: "Controls", pages: getPages(["CompaniesPage", "UsersPage"])});
  return pages;
}

function createUserRoleRoutes() {
  return getPages(["HomePage", "TerminalSwitchPage"]);
}

function createHelpDeskRoleRoutes() {
  return getPages(["HomePage", "TerminalsPage", "PartsPage", "StationsPage", "TerminalSwitchPage", "CompaniesPage", "UsersPage"]);
}

function createViewerRoleRoutes() {
  return getPages(["HomePage", "TerminalsPage", "StationsPage"]);
}


function createNullRoleRoutes() {
  return getPages(["LoginPage"]);
}


// Helper function for getting spesific pages from pageMap
// by strings in array
function getPages(pageNames) {
  return pageNames.map(pageName => {
    return pageMap.get(pageName);
  })
}

// Helper function for creating a map where there is 
// stored a terminalsPage function (component) and its
// name as string. 
export const createRouteMap = () => {
  const myMap = new Map();
  myMap.set("LoginPage", LoginPage);
  myMap.set("HomePage", HomePage);
  myMap.set("TerminalsPage", TerminalsPage);
  myMap.set("PartsPage", PartsPage);
  myMap.set("TerminalSwitchPage", StepPage);
  myMap.set("CompaniesPage", CompaniesPage);
  myMap.set("UsersPage", UsersPage);
  myMap.set("StationsPage", StationsPage);
  return myMap;
}


// Helper function for creating a map where there is 
// stored a terminalsPage function (component) and its
// name as string. 
export const createIconMap = () => {
  const myMap = new Map();
  myMap.set("LoginPage", HomeIcon);
  myMap.set("HomePage", HomeIcon);
  myMap.set("TerminalsPage", DevicesIcon);
  myMap.set("PartsPage", BuildIcon);
  myMap.set("TerminalSwitchPage", SwapCallsIcon);
  myMap.set("CompaniesPage", BusinessIcon);
  myMap.set("UsersPage", PeopleIcon);
  myMap.set("StationsPage", EvStationIcon);
  return myMap;
}


// WEBPACK FOOTER //
// ./src/utils/routes.js